module.exports = __webpack_public_path__ + "static/media/29180022-min.a1fdfc00.jpg";